import {Component, inject, input, OnChanges, SimpleChanges} from '@angular/core';
import {ExternalProfile} from "../../../models/external-profile.model";
import {FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ExpandableInputComponent} from "../../expandable-input/expandable-input.component";
import {
  RdsButtonModule,
  RdsDatepickerModule,
  RdsDividerModule, RdsFormFieldModule, RdsIconComponent} from "@rds/angular-components";

type DetailedViewForm = FormGroup<{
  titles: FormArray<FormControl<string | null>>;
  firstName: FormControl<string>;
  lastName: FormControl<string>;
  institution: FormControl<string>;
  country: FormControl<string>;
}>

@Component({
  selector: 'app-external-profile-detail-view',
  standalone: true,
  imports: [
    ExpandableInputComponent,
    FormsModule,
    RdsButtonModule,
    RdsDatepickerModule,
    RdsDividerModule,
    RdsFormFieldModule,
    RdsIconComponent,
    ReactiveFormsModule
  ],
  templateUrl: './external-profile-detail-view.component.html',
  styleUrl: './external-profile-detail-view.component.scss',
})
export class ExternalProfileDetailViewComponent implements OnChanges {
  externalProfile = input.required<ExternalProfile>();
  private readonly formBuilder = inject(FormBuilder)
  form!: DetailedViewForm;
  titleListExpanded = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['externalProfile']) {
      this.setupForm()
    }
  }

  setupForm() {
    const e = this.externalProfile()

    this.form = this.formBuilder.group({
      titles: this.formBuilder.array(e.titles?.map(title => this.formBuilder.control({value: title, disabled: true})) || []),
      firstName: this.formBuilder.control({value: e.firstName, disabled: true}, {nonNullable: true}),
      lastName: this.formBuilder.control({value: e.lastName, disabled: true}, {nonNullable: true}),
      institution: this.formBuilder.control({value: e.institution, disabled: true}, {nonNullable: true}),
      country: this.formBuilder.control({value: e.country, disabled: true}, {nonNullable: true}),
    })
  }
}
